var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"residential-cover__wrapper content"},[(_vm.items.length)?_c('Slider',{staticClass:"residential-cover",attrs:{"value":_vm.items,"display-thumbnail":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }